import { useEffect, useState, useRef } from 'react'
import { AUTH_ME_API } from '../api'
/* import { AUTH_STATUS_API } from '../lib/api' */

// Le jeton JWT a une durée de vie volontairement courte côté serveur (voir
// JWT_TTL) — sans renouvellement périodique, une session ouverte plus
// longtemps que cette durée déconnecterait l'utilisateur en pleine journée de
// travail. /auth/me renvoie déjà un jeton frais à chaque appel (voir
// AuthController::me(), JWTAuth::refresh()) ; il suffit de le rappeler
// régulièrement tant que l'app reste ouverte plutôt qu'une seule fois au chargement.
const INTERVALLE_RENOUVELLEMENT_MS = 30 * 60 * 1000

export const useAuthStatus = () => {
  const [loggedIn, setLoggedIn] = useState(false)
  const [checkingStatus, setCheckingStatus] = useState(true)
  const isMounted = useRef(true)
  const token = sessionStorage.getItem('token')
  useEffect(() => {
    function verifierEtRenouveler() {
      try {
        const { url, ...rest } = AUTH_ME_API

        fetch(url, { ...rest, credentials: "include" }).then(async (res) => {
          if (res.status === 200) {

            const data = await res.json()
            const { token, user, role, profile, personnel, permissions } = data
            setLoggedIn(true)
            sessionStorage.setItem('token', token)
            sessionStorage.setItem('user', JSON.stringify({ ...user, role, profile, personnel, permissions }))
            // Navbar/Sidebar se montent avant la fin de cet appel (ils ne dépendent
            // que de la route, pas de l'état d'auth) : sans ce signal, ils gardent
            // un utilisateur vide (donc pas de photo/nom) tant qu'aucune navigation
            // ne se produit.
            window.dispatchEvent(new Event('user-updated'))
            setCheckingStatus(false)
          }
          else {
            // Un 401 ici (jeton rejeté — voir AuthPersonnelMiddleware, qui peut
            // désormais refuser un jeton valide après 2h sans requête, voir
            // aussi AlerterInactiviteImminente côté backend) doit repasser
            // loggedIn à false, sinon PrivateRoute continue d'afficher les
            // pages protégées avec un état figé alors que chaque appel API
            // échoue silencieusement en arrière-plan.
            if (res.status === 401) {
              sessionStorage.clear()
              setLoggedIn(false)
            }
            setCheckingStatus(false)
          }
        }).catch(function (err) {
          setCheckingStatus(false)
          console.log(err)
        })
      } catch (error) {
        setCheckingStatus(false)
        console.log(error)
      }
    }

    if (isMounted) {
      verifierEtRenouveler()
    }
    const intervalle = setInterval(verifierEtRenouveler, INTERVALLE_RENOUVELLEMENT_MS)
    return () => {
      isMounted.current = false
      clearInterval(intervalle)
    }
  }, [isMounted, token])
  return { loggedIn, checkingStatus }
}